
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full lyrics of Aarti "Aarti hi tujala deva maharudra" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Aarti hi tujala deva maharudra" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Maharudra Aarti, Shiva Aarti, aarti hi tujala deva maharudra lyrics, Aarti hi tujala deva maharudra, आरती ही तूजला देवा महारुद्रा, महारुद्राची आरती'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'Maharudra Aarti, Shiva Aarti, Aarti lyrics, Marathi Aarti, devotional aarti, worship, Lord Shiva, aarti hi tujala deva maharudra lyrics, aarti hi tujala deva maharudra lyrics in marathi, aarti hi tujala deva maharudra lyrics in english, आरती ही तूजला देवा महारुद्रा, Maharudra Aarti'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/maharudra.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/maharudra.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Aarti hi tujala deva maharudra | Maharudra Aarti - आरती ही तूजला देवा महारुद्रा (महारुद्राची आरती)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
      
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/maharudra"
        },
        "headline": "Aarti hi tujala deva maharudra - आरती ही तूजला देवा महारुद्रा (महारुद्राची आरती)",
        "name" : "Aarti hi tujala deva maharudra - Maharudra Aarti",
        "description": "Explore the full lyrics of Aarti 'Aarti hi tujala deva maharudra' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/maharudra.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  